module.exports = __webpack_public_path__ + "static/media/thumb.b1b8bbf4.jpg";